if (!customElements.get('custom-bundle-builder')) {
  class CustomBundleBuilder extends HTMLElement {
    constructor() {
      super();

      this.config = this.readConfig();
      this.isPickerMode = this.config.mode === 'picker' && !!(this.config.picker && this.config.picker.options && this.config.picker.options.length);
      this.addColorsLabel = this.dataset.addColorsLabel;
      this.pickedColorsLabel = this.dataset.pickedColorsLabel;
      this.pickSlotsLabelTemplate = this.getPickSlotsLabelTemplate();
      var slots = 3;
      if (this.isPickerMode && this.config.picker && this.config.picker.slots_count) {
        slots = parseInt(this.config.picker.slots_count, 10);
      } else if (this.config && this.config.colors_slots_count) {
        slots = parseInt(this.config.colors_slots_count, 10);
      }
      if (!slots || isNaN(slots) || slots < 1) slots = 1;
      this.slotsCount = slots;

      this.state = {
        selectedTopCoat: null,
        selectedAccessory: null,
        selectedSizeShapeKey: null,
        selectedColors: new Array(this.slotsCount).fill(null)
      };
      this.cacheDom();
      this.initStateFromPreselection();
      this.bindEvents();
      this.render();
    }

    readConfig() {
      var raw = this.dataset.bundleConfig;
      if (!raw) {
        var sectionId = this.dataset.sectionId;
        var productId = this.dataset.productId;
        if (sectionId && productId) {
          var scriptEl = document.getElementById('bundle-config-' + sectionId + '-' + productId);
          if (scriptEl) raw = scriptEl.textContent;
        }
      }
      if (!raw) return { mode: 'legacy', top_coats: [], sizes_shapes: [], included_products: [], accessories: [], colors_by_shape: {}, reset_selections_on_option_change: true };

      try {
        return JSON.parse(raw);
      } catch (e) {
        console.error('Invalid bundle config JSON', e);
        return { mode: 'legacy', top_coats: [], sizes_shapes: [], included_products: [], accessories: [], colors_by_shape: {}, reset_selections_on_option_change: true };
      }
    }

    isProductAvailable() {
      if (this.dataset.productAvailable !== undefined) {
        return this.dataset.productAvailable === 'true';
      }
      var main = this.closest('.product-main-element');
      return main ? main.classList.contains('available') : true;
    }

    shouldResetOnOptionChange() {
      if (this.isPickerMode && this.config.picker) {
        return this.config.picker.reset_on_option_change !== false;
      }
      return this.config.reset_selections_on_option_change !== false;
    }

    getPickSlotsLabelTemplate() {
      var fromDataset = this.dataset.pickSlotsLabel;
      if (fromDataset && String(fromDataset).trim()) return String(fromDataset).trim();
      if (this.isPickerMode && this.config.picker && this.config.picker.pick_slots_label) {
        var fromConfig = String(this.config.picker.pick_slots_label).trim();
        if (fromConfig) return fromConfig;
      }
      return '';
    }

    getModalSelectedItemFallback() {
      return this.dataset.modalSelectedItemLabel || (this.isPickerMode ? 'Selected item' : 'Selected color');
    }

    formatPickerLabel(count) {
      var n = parseInt(count, 10);
      if (!n || isNaN(n) || n < 1) n = 1;
      var template = this.getPickSlotsLabelTemplate();
      if (!template) {
        if (this.isPickerMode) return 'Pick ' + n + ' item' + (n > 1 ? 's' : '');
        return 'Pick ' + n + ' Color' + (n > 1 ? 's' : '');
      }
      if (/\{\{\s*count\s*\}\}/i.test(template)) {
        return template.replace(/\{\{\s*count\s*\}\}/gi, String(n));
      }
      var totalStr = String(this.slotsCount);
      if (totalStr && template.indexOf(totalStr) !== -1) {
        return template.split(totalStr).join(String(n));
      }
      if (/\d+/.test(template)) return template.replace(/\d+/, String(n));
      if (/^\s*pick\b/i.test(template)) {
        return template.replace(/^(\s*)pick\b/i, '$1Pick ' + n);
      }
      return 'Pick ' + n + ' ' + template;
    }

    getPickedModalLabel() {
      if (this.pickedColorsLabel) return this.pickedColorsLabel;
      if (this.isPickerMode) {
        var template = this.getPickSlotsLabelTemplate();
        if (template) {
          if (template.indexOf('') !== -1) {
            return template.replace(/^Pick/i, 'Picked').replace(/\{\{\s*count\s*\}\}/g, String(this.slotsCount));
          }
          if (/\d+/.test(template)) {
            return template.replace(/^Pick/i, 'Picked').replace(/\d+/, String(this.slotsCount));
          }
          return template.replace(/^Pick/i, 'Picked');
        }
        return 'Picked ' + this.slotsCount + ' items';
      }
      return 'Picked ' + this.slotsCount + ' Colors';
    }

    getModalAddButtonLabel(isComplete) {
      var addItemLabel = this.dataset.modalAddItemLabel || 'Add';
      if (isComplete) {
        return this.addColorsLabel || (this.isPickerMode ? 'Add selections to the bundle' : 'Add colors to the bundle');
      }
      if (this.isPickerMode) {
        var pickTemplate = this.getPickSlotsLabelTemplate();
        if (pickTemplate) {
          var match = pickTemplate.match(/Pick\s+\d+\s+(.+)$/i);
          if (match && match[1]) {
            var noun = match[1].trim();
            if (noun.length > 1 && noun.slice(-1) === 's') noun = noun.slice(0, -1);
            return addItemLabel + ' ' + noun;
          }
        }
        return addItemLabel;
      }
      return 'Add Color';
    }

    cacheDom() {
      this.pickColorsRoot = this.querySelector('[data-bundle-pick-colors]');
      this.pickColorsSmallLabel = this.pickColorsRoot ? this.pickColorsRoot.querySelector('.small-label') : null;
      this.sizeShapeWarning = this.querySelector('[data-bundle-size-shape-warning]');
      this.slotButtons = this.querySelectorAll('[data-bundle-color-slot]');
      this.pickButton = this.querySelector('[data-bundle-open-picker]');
      this.form = this.closest('form');
      this.topCoatOptions = this.querySelectorAll('[data-bundle-top-coat-option]');
      this.accessoryOptions = this.querySelectorAll('[data-bundle-accessory-option]');
      this.sizeShapeOptions = this.querySelectorAll('[data-bundle-size-shape]');

      if (this.form) {
        this.inputTopCoat = this.form.querySelector('input[name="properties[clbrtps_bundle_top_coat]"]');
        this.inputAccessory = this.form.querySelector('input[name="properties[clbrtps_bundle_accessory]"]');
        this.inputColor1 = this.form.querySelector('input[name="properties[clbrtps_bundle_color_1]"]');
        this.inputColor2 = this.form.querySelector('input[name="properties[clbrtps_bundle_color_2]"]');
        this.inputColor3 = this.form.querySelector('input[name="properties[clbrtps_bundle_color_3]"]');
        this.inputColor4 = this.form.querySelector('input[name="properties[clbrtps_bundle_color_4]"]');
        this.inputColor5 = this.form.querySelector('input[name="properties[clbrtps_bundle_color_5]"]');
        this.addButton = this.form.querySelector('product-buttons .btn.add');
      }
    }

    initStateFromPreselection() {
      if (this.topCoatOptions && this.topCoatOptions.length > 0) {
        var first = this.topCoatOptions[0];
        this.state.selectedTopCoat = {
          productId: first.dataset.productId ? parseInt(first.dataset.productId, 10) : null,
          variantId: first.dataset.variantId ? parseInt(first.dataset.variantId, 10) : null,
          title: first.dataset.title || ''
        };
      }
      if (this.sizeShapeOptions && this.sizeShapeOptions.length > 0) {
        this.state.selectedSizeShapeKey = this.sizeShapeOptions[0].dataset.shapeKey || '';
      }
      if (this.accessoryOptions && this.accessoryOptions.length > 0) {
        var first = this.accessoryOptions[0];
        this.state.selectedAccessory = {
          productId: first.dataset.productId ? parseInt(first.dataset.productId, 10) : null,
          variantId: first.dataset.variantId ? parseInt(first.dataset.variantId, 10) : null,
          title: first.dataset.title || ''
        };
      }
    }

    bindEvents() {
      var self = this;

      this.bindTopCoatEvents();
      this.bindAccessoryEvents();
      this.bindSizeShapeEvents();
      this.bindInfoBadgeEvents();
      this.bindAddToCart();

      if (!this.pickColorsRoot) return;

      if (this.pickButton) {
        this.pickButton.addEventListener('click', function(e) {
          if (!self.isProductAvailable()) return;
          if (self.getSelectedColorsCount() < self.slotsCount) {
            e.preventDefault();
            self.openColorsModal();
          }
        });
      }

      if (this.slotButtons && this.slotButtons.length) {
        this.slotButtons.forEach(function(slotBtn) {
          slotBtn.addEventListener('click', function() {
            if (!self.isProductAvailable()) return;
            self.openColorsModal();
          });
        });
      }

      this.pickColorsRoot.addEventListener('click', function(e) {
        if (!self.isProductAvailable()) return;
        var removeBtn = e.target.closest('[data-bundle-remove-slot]');
        if (!removeBtn) return;
        var index = parseInt(removeBtn.dataset.bundleRemoveSlot, 10);
        if (isNaN(index)) return;
        self.removeColorAt(index);
      });
    }

    bindTopCoatEvents() {
      var self = this;
      if (!this.topCoatOptions || !this.topCoatOptions.length) return;
      this.topCoatOptions.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var productId = btn.dataset.productId ? parseInt(btn.dataset.productId, 10) : null;
          var variantId = btn.dataset.variantId ? parseInt(btn.dataset.variantId, 10) : null;
          var title = btn.dataset.title || '';
          self.state.selectedTopCoat = { productId: productId, variantId: variantId, title: title };
          self.topCoatOptions.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          self.render();
        });
      });
    }

    bindAccessoryEvents() {
      var self = this;
      if (!this.accessoryOptions || !this.accessoryOptions.length) return;
      this.accessoryOptions.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var productId = btn.dataset.productId ? parseInt(btn.dataset.productId, 10) : null;
          var variantId = btn.dataset.variantId ? parseInt(btn.dataset.variantId, 10) : null;
          var title = btn.dataset.title || '';
          self.state.selectedAccessory = { productId: productId, variantId: variantId, title: title };
          self.accessoryOptions.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          self.render();
        });
      });
    }

    bindSizeShapeEvents() {
      var self = this;
      if (!this.sizeShapeOptions || !this.sizeShapeOptions.length) return;
      this.sizeShapeOptions.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = btn.dataset.shapeKey || '';
          self.state.selectedSizeShapeKey = key;

          if (self.shouldResetOnOptionChange() && self.getSelectedColorsCount() > 0) {
            self.state.selectedColors = new Array(self.slotsCount).fill(null);
          }
          self.sizeShapeOptions.forEach(function(b) {
            b.classList.remove('is-active');
            b.classList.remove('active');
          });
          btn.classList.add('is-active');
          btn.classList.add('active');
          self.render();
        });
      });
    }

    resolveVariantId(val, configList) {
      var id = val && (val.variantId || val.variant_id) ? parseInt(val.variantId || val.variant_id, 10) : null;
      if (id && !isNaN(id) && id > 0) return id;
      if (!configList || !configList.length || !val) return null;
      var title = String(val.title || '').trim();
      var titleBase = title.split('(')[0].trim();
      var productId = val.productId || val.product_id;
      if (productId) productId = parseInt(productId, 10);
      var handle = String(val.handle || '').trim();
      for (var i = 0; i < configList.length; i++) {
        var c = configList[i];
        var cProductId = c.product_id || c.productId;
        if (cProductId) cProductId = parseInt(cProductId, 10);
        var cTitle = String(c.title || '').trim();
        var cTitleBase = cTitle.split('(')[0].trim();
        var cHandle = String(c.handle || '').trim();
        var titleMatch = (title && cTitle && (title === cTitle || titleBase === cTitleBase || title.indexOf(cTitle) === 0 || cTitle.indexOf(title) === 0));
        var productMatch = productId && cProductId && productId === cProductId;
        var handleMatch = handle && cHandle && handle === cHandle;
        if ((titleMatch || productMatch || handleMatch) && (c.variant_id || c.variantId)) {
          var vid = parseInt(c.variant_id || c.variantId, 10);
          if (!isNaN(vid) && vid > 0) return vid;
        }
      }
      return null;
    }

    getPickerOptionByKey(key) {
      if (!key || !this.isPickerMode || !this.config.picker || !this.config.picker.options) return null;
      var options = this.config.picker.options;
      var normalized = String(key).replace(/\u00A0/g, ' ');
      for (var i = 0; i < options.length; i++) {
        if (options[i] && options[i].key === normalized) return options[i];
      }
      return null;
    }

    getOptionGroupFromCollectionHandle(handle) {
      var h = String(handle || '').toLowerCase();
      if (h.indexOf('finish') !== -1) return 'finish';
      if (h.indexOf('shape') !== -1) return 'shape';
      if (h.indexOf('style') !== -1) return 'style';
      return 'default';
    }

    getBundleMessageAttr(name) {
      var raw = this.getAttribute(name);
      if (!raw) return '';
      var el = document.createElement('textarea');
      el.innerHTML = raw;
      return el.value;
    }

    getOptionChangeWarningMessage() {
      if (!this.isPickerMode) {
        return this.getBundleMessageAttr('data-legacy-option-warning') || 'Changing Size & Shape will reset the current selection';
      }
      var opt = this.getPickerOptionByKey(this.state.selectedSizeShapeKey);
      var handle = opt && opt.collection_handle ? opt.collection_handle : '';
      var group = this.getOptionGroupFromCollectionHandle(handle);
      var messages = {
        finish: this.getBundleMessageAttr('data-picker-warning-finish'),
        shape: this.getBundleMessageAttr('data-picker-warning-shape'),
        style: this.getBundleMessageAttr('data-picker-warning-style'),
        default: this.getBundleMessageAttr('data-picker-warning-default')
      };
      return messages[group] || messages.default || messages.finish;
    }

    getOptionChangeKeepMessage() {
      if (!this.isPickerMode) {
        return this.getBundleMessageAttr('data-legacy-option-keep') || 'Changing Size & Shape will not reset the current selection—you can mix combinations';
      }
      var opt = this.getPickerOptionByKey(this.state.selectedSizeShapeKey);
      var handle = opt && opt.collection_handle ? opt.collection_handle : '';
      var group = this.getOptionGroupFromCollectionHandle(handle);
      var messages = {
        finish: this.getBundleMessageAttr('data-picker-keep-finish'),
        shape: this.getBundleMessageAttr('data-picker-keep-shape'),
        style: this.getBundleMessageAttr('data-picker-keep-style'),
        default: this.getBundleMessageAttr('data-picker-keep-default')
      };
      return messages[group] || messages.default || messages.finish;
    }

    getColorsForShapeKey(shapeKey) {
      if (!shapeKey) return [];
      var key = String(shapeKey).replace(/\u00A0/g, ' ');

      if (this.isPickerMode && this.config.picker && this.config.picker.products_by_option_key) {
        var pickerMap = this.config.picker.products_by_option_key;
        if (pickerMap[key] && Array.isArray(pickerMap[key])) return pickerMap[key];
        return [];
      }

      var map = this.config && this.config.colors_by_shape ? this.config.colors_by_shape : {};
      if (!map || typeof map !== 'object') return [];
      if (map[key] && Array.isArray(map[key])) return map[key];
      return [];
    }

    formatColorTitleForCart(color) {
      if (!color || !color.title) return '';
      return String(color.title).trim();
    }

    getPickerOptionLabel(optionKey) {
      if (!optionKey) return '';
      var key = String(optionKey);
      if (this.sizeShapeOptions && this.sizeShapeOptions.length) {
        for (var si = 0; si < this.sizeShapeOptions.length; si++) {
          var shapeBtn = this.sizeShapeOptions[si];
          if (shapeBtn && shapeBtn.dataset.shapeKey === key) return shapeBtn.dataset.shapeLabel || '';
        }
      }
      var options = this.config && this.config.picker && this.config.picker.options;
      if (options && options.length) {
        for (var i = 0; i < options.length; i++) {
          if (options[i] && options[i].key === key) return options[i].label || '';
        }
      }
      return key;
    }

    getPickItemLabel() {
      if (this.isPickerMode && this.config.picker && this.config.picker.cart_pick_item_label) {
        var fromConfig = String(this.config.picker.cart_pick_item_label).trim();
        if (fromConfig) return fromConfig;
      }
      return 'Color';
    }

    /** Picker-only v2 line properties (cart display + checkout validation). Legacy never calls this. */
    normalizePickerRelatedRole(bundleItemValue) {
      if (!bundleItemValue || bundleItemValue === 'clbrtps_bundle_main') return '';
      if (bundleItemValue === 'clbrtps_bundle_related_top_coat') return 'top_coat';
      if (bundleItemValue === 'clbrtps_bundle_related_accessory') return 'accessory';
      if (bundleItemValue.indexOf('clbrtps_bundle_related_included_') === 0) return 'included';
      if (bundleItemValue.indexOf('clbrtps_bundle_related_color_') === 0) return 'pick';
      return '';
    }

    applyPickerBundleV2Props(mainProps, items, mainVariantId, pickVariantIds, pickOptionMeta) {
      if (!this.isPickerMode || !mainProps || !items) return;

      var pickItemLabel = this.getPickItemLabel();
      var productId = this.dataset.productId ? String(this.dataset.productId) : '';
      var uniqueKeys = [];
      var uniqueLabels = [];
      var self = this;

      mainProps['_clbrtps_bundle_mode'] = 'picker';
      mainProps['_clbrtps_bundle_version'] = '2';
      mainProps['_clbrtps_bundle_slots'] = String(this.slotsCount);
      mainProps['_clbrtps_bundle_pick_item_label'] = pickItemLabel;
      mainProps['_clbrtps_bundle_product_id'] = productId;
      mainProps['_clbrtps_bundle_main_variant_id'] = String(mainVariantId);
      mainProps['_clbrtps_bundle_position'] = '1';

      (pickVariantIds || []).forEach(function(variantId, index) {
        var meta = pickOptionMeta && pickOptionMeta[index] ? pickOptionMeta[index] : null;
        var slotKey = (meta && meta.optionKey) ? meta.optionKey : (self.state.selectedSizeShapeKey || '');
        var slotLabel = (meta && meta.optionLabel) ? meta.optionLabel : self.getPickerOptionLabel(slotKey);

        if (variantId && !isNaN(variantId) && variantId > 0) {
          var slotIndex = index + 1;
          mainProps['_clbrtps_bundle_pick_' + slotIndex + '_variant_id'] = String(variantId);
          if (slotKey) {
            mainProps['_clbrtps_bundle_pick_' + slotIndex + '_option_key'] = slotKey;
            mainProps['_clbrtps_bundle_pick_' + slotIndex + '_option_label'] = slotLabel;
          }
        }

        if (slotKey && uniqueKeys.indexOf(slotKey) === -1) {
          uniqueKeys.push(slotKey);
          uniqueLabels.push(slotLabel);
        }
      });

      var fallbackKey = this.state.selectedSizeShapeKey || '';
      if (!uniqueKeys.length && fallbackKey) {
        uniqueKeys.push(fallbackKey);
        uniqueLabels.push(this.getPickerOptionLabel(fallbackKey));
      }

      if (uniqueKeys.length <= 1) {
        mainProps['_clbrtps_bundle_option_key'] = uniqueKeys[0] || fallbackKey;
        mainProps['_clbrtps_bundle_option_label'] = uniqueLabels[0] || this.getPickerOptionLabel(fallbackKey);
      } else {
        mainProps['_clbrtps_bundle_option_key'] = uniqueKeys.join(',');
        mainProps['_clbrtps_bundle_option_label'] = uniqueLabels.join(', ');
        mainProps['_clbrtps_bundle_option_keys'] = uniqueKeys.join(',');
        mainProps['_clbrtps_bundle_option_labels'] = uniqueLabels.join(', ');
      }

      var manifestParts = ['v2', 'k:' + (uniqueKeys.join(',') || fallbackKey), 'm:' + mainVariantId];
      if (productId) manifestParts.push('pid:' + productId);

      (pickVariantIds || []).forEach(function(variantId, index) {
        if (!variantId || isNaN(variantId) || variantId <= 0) return;
        var meta = pickOptionMeta && pickOptionMeta[index] ? pickOptionMeta[index] : null;
        var slotKey = (meta && meta.optionKey) ? meta.optionKey : (self.state.selectedSizeShapeKey || '');
        var manifestPick = 'p' + (index + 1) + ':' + variantId;
        if (slotKey) manifestPick += '@' + slotKey;
        manifestParts.push(manifestPick);
      });

      items.forEach(function(cartItem, index) {
        if (!cartItem || !cartItem.properties) return;
        var role = cartItem.properties._clbrtps_bundle_item || '';
        var vid = cartItem.id;
        var position = String(index + 1);
        var normalizedRole = this.normalizePickerRelatedRole(role);

        cartItem.properties['_clbrtps_bundle_mode'] = 'picker';
        cartItem.properties['_clbrtps_bundle_version'] = '2';
        cartItem.properties['_clbrtps_bundle_position'] = position;

        if (role !== 'clbrtps_bundle_main') {
          if (vid) cartItem.properties['_clbrtps_bundle_related_variant_id'] = String(vid);
          if (normalizedRole) cartItem.properties['_clbrtps_bundle_related_role'] = normalizedRole;
          if (role.indexOf('clbrtps_bundle_related_color_') === 0) {
            var slotNum = parseInt(role.replace('clbrtps_bundle_related_color_', ''), 10);
            var pickMeta = pickOptionMeta && pickOptionMeta[slotNum - 1] ? pickOptionMeta[slotNum - 1] : null;
            if (pickMeta && pickMeta.optionKey) {
              cartItem.properties['_clbrtps_bundle_pick_option_key'] = pickMeta.optionKey;
              if (pickMeta.optionLabel) cartItem.properties['_clbrtps_bundle_pick_option_label'] = pickMeta.optionLabel;
            }
          }
        }

        if (role === 'clbrtps_bundle_related_top_coat') manifestParts.push('tc:' + vid);
        else if (role === 'clbrtps_bundle_related_accessory') manifestParts.push('a:' + vid);
        else if (role.indexOf('clbrtps_bundle_related_included_') === 0) {
          manifestParts.push('i' + role.replace('clbrtps_bundle_related_included_', '') + ':' + vid);
        }
      }, this);

      manifestParts.push('lc:' + items.length);
      mainProps['_clbrtps_bundle_line_count'] = String(items.length);

      var manifest = manifestParts.join(';');
      if (manifest.length <= 255) {
        mainProps['_clbrtps_bundle_manifest'] = manifest;
      }

      return mainProps;
    }

    buildBundleCartItems() {
      var self = this;
      var mainVariantInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      var mainVariantId = mainVariantInput && mainVariantInput.value ? parseInt(mainVariantInput.value, 10) : null;
      if (!mainVariantId || isNaN(mainVariantId)) {
        mainVariantId = this.dataset.defaultVariantId ? parseInt(this.dataset.defaultVariantId, 10) : null;
      }
      if (!mainVariantId || isNaN(mainVariantId)) return null;

      var bundleId = String(new Date().getTime());
      var mainProps = {
        '_clbrtps_bundle_top_coat': (this.state.selectedTopCoat && this.state.selectedTopCoat.title) || '',
        '_clbrtps_bundle_accessory': (this.state.selectedAccessory && this.state.selectedAccessory.title) || '',
        '_clbrtps_bundle_id': bundleId,
        '_clbrtps_bundle_item': 'clbrtps_bundle_main'
      };

      // Map color titles onto _clbrtps_bundle_color_1..N for the main cart item
      for (var ci = 0; ci < this.slotsCount; ci++) {
        var color = this.state.selectedColors[ci];
        mainProps['_clbrtps_bundle_color_' + (ci + 1)] = color ? this.formatColorTitleForCart(color) : '';
      }

      var lockProps = function(itemType) {
        return { '_locked': 'quantity', '_clbrtps_bundle_id': bundleId, '_clbrtps_bundle_item': 'clbrtps_bundle_related_' + itemType };
      };

      var items = [
        { id: mainVariantId, quantity: 1, properties: mainProps }
      ];

      // Included products from bundle config (each one added as quantity 1 related item).
      var includedProducts = (this.config && (this.config.included_products || this.config['included-products'])) || [];
      if (!Array.isArray(includedProducts)) includedProducts = [];
      includedProducts.forEach(function(incProduct, i) {
        var rawVariantId = incProduct && (incProduct.variant_id || incProduct.variantId) ? (incProduct.variant_id || incProduct.variantId) : null;
        var variantId = rawVariantId ? parseInt(rawVariantId, 10) : null;
        if (!variantId || isNaN(variantId) || variantId <= 0) return;

        var itemIndex = i + 1;
        var props = lockProps('included_' + itemIndex);
        props['_clbrtps_bundle_included_' + itemIndex] = incProduct && incProduct.title ? String(incProduct.title) : '';

        mainProps['_clbrtps_bundle_included_' + itemIndex] = incProduct && incProduct.title ? String(incProduct.title) : '';

        items.push({ id: variantId, quantity: 1, properties: props });
      });

      // Top Coats
      var tcId = this.resolveVariantId(this.state.selectedTopCoat, this.config && this.config.top_coats);
      if (tcId) items.push({ id: tcId, quantity: 1, properties: lockProps('top_coat') });

      // Accessory
      var accId = this.resolveVariantId(this.state.selectedAccessory, this.config && this.config.accessories);
      if (accId) items.push({ id: accId, quantity: 1, properties: lockProps('accessory') });

      // Colors / picker slot products
      var pickVariantIds = [];
      var pickOptionMeta = [];
      (this.state.selectedColors || []).forEach(function(c, i) {
        var colorId = null;
        if (c && (c.variantId || c.variant_id)) {
          colorId = parseInt(c.variantId || c.variant_id, 10);
        }
        var shapeKeyForColor = (self.isPickerMode && c && c.optionKey) ? c.optionKey : self.state.selectedSizeShapeKey;
        var optionLabelForColor = (c && c.optionLabel) ? c.optionLabel : self.getPickerOptionLabel(shapeKeyForColor || '');
        pickOptionMeta[i] = {
          optionKey: shapeKeyForColor || '',
          optionLabel: optionLabelForColor || ''
        };
        var configList = self.getColorsForShapeKey(shapeKeyForColor);
        if (!colorId && c && c.configIndex >= 0 && configList && configList[c.configIndex]) {
          var cfg = configList[c.configIndex];
          var vid = cfg && (cfg.variant_id || cfg.variantId);
          if (vid) colorId = parseInt(vid, 10);
        }
        pickVariantIds[i] = colorId && !isNaN(colorId) && colorId > 0 ? colorId : null;
        if (colorId && !isNaN(colorId) && colorId > 0) items.push({ id: colorId, quantity: 1, properties: lockProps('color_' + (i + 1)) });
      });

      var filtered = items.filter(function(item) { var id = item.id; return id && !isNaN(id) && id > 0; });
      if (this.isPickerMode && filtered.length && filtered[0].properties) {
        this.applyPickerBundleV2Props(filtered[0].properties, filtered, mainVariantId, pickVariantIds, pickOptionMeta);
      }
      return filtered;
    }

    resetBundleFormState() {
      this.state.selectedColors = new Array(this.slotsCount).fill(null);
      if (this.topCoatOptions && this.topCoatOptions.length > 0) {
        var first = this.topCoatOptions[0];
        this.state.selectedTopCoat = { productId: first.dataset.productId ? parseInt(first.dataset.productId, 10) : null, variantId: first.dataset.variantId ? parseInt(first.dataset.variantId, 10) : null, title: first.dataset.title || '' };
        this.topCoatOptions.forEach(function(b) { b.classList.remove('is-active'); });
        this.topCoatOptions[0].classList.add('is-active');
      }
      if (this.accessoryOptions && this.accessoryOptions.length > 0) {
        var first = this.accessoryOptions[0];
        this.state.selectedAccessory = { productId: first.dataset.productId ? parseInt(first.dataset.productId, 10) : null, variantId: first.dataset.variantId ? parseInt(first.dataset.variantId, 10) : null, title: first.dataset.title || '' };
        this.accessoryOptions.forEach(function(b) { b.classList.remove('is-active'); });
        this.accessoryOptions[0].classList.add('is-active');
      }
      if (this.sizeShapeOptions && this.sizeShapeOptions.length > 0) {
        this.state.selectedSizeShapeKey = this.sizeShapeOptions[0].dataset.shapeKey || '';
        this.sizeShapeOptions.forEach(function(b) { b.classList.remove('is-active'); b.classList.remove('active'); });
        this.sizeShapeOptions[0].classList.add('is-active'); this.sizeShapeOptions[0].classList.add('active');
      }
      this.syncLineItemProperties();
      this.render();
      this.updateButtonsVisibility();
    }

    handleBundleAddToCart(e) {
      var self = this;
      if (!this.isProductAvailable()) return;
      if (this.getSelectedColorsCount() !== this.slotsCount) return;
      e.preventDefault();
      e.stopPropagation();

      var items = this.buildBundleCartItems();
      if (!items || items.length === 0) {
        if (typeof $s !== 'undefined' && typeof $s.addToCartFail === 'function') $s.addToCartFail('Unable to add bundle to cart. Please refresh and try again.');
        return;
      }

      var addButtons = this.form ? this.form.querySelectorAll('product-buttons .btn.add') : [];
      addButtons.forEach(function(btn) { btn.disabled = true; });
      if (typeof $s !== 'undefined' && $s.showLoadingOverlay) $s.showLoadingOverlay();

      var cartUrl = (typeof routes !== 'undefined' ? routes.cart_url : '/cart') + '/add.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.ok ? r.json() : r.json().then(function(d) { throw new Error(d.description || 'Add to cart failed'); }); })
      .then(function() {
        window.dispatchEvent(new Event('cart:updated'));
        self.resetBundleFormState();
        if (typeof $s !== 'undefined' && typeof $s.addToCartSuccess === 'function') $s.addToCartSuccess();
      })
      .catch(function(err) {
        if (typeof $s !== 'undefined' && typeof $s.addToCartFail === 'function') $s.addToCartFail(err.message);
        else alert(err.message);
      })
      .finally(function() {
        addButtons.forEach(function(btn) { btn.disabled = false; });
        if (typeof $s !== 'undefined' && $s.hideLoadingOverlay) $s.hideLoadingOverlay();
      });
    }

    bindAddToCart() {
      var self = this;
      var addButtons = this.form ? this.form.querySelectorAll('product-buttons .btn.add') : [];
      addButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          if (!self.isProductAvailable()) return;
          if (self.getSelectedColorsCount() === self.slotsCount) {
            self.handleBundleAddToCart(e);
          }
        }, true);
      });
    }

    bindInfoBadgeEvents() {
      this.querySelectorAll('[data-bundle-info-badge]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var targetId = btn.dataset.bundleInfoTarget;
          if (!targetId) return;
          var contentEl = document.getElementById(targetId);
          var html = contentEl ? contentEl.innerHTML : '';
          var schemeClass = contentEl && contentEl.dataset.bundleInfoScheme ? contentEl.dataset.bundleInfoScheme : '';
          var infoType = btn.dataset.bundleInfoType || '';
          if (typeof $s !== 'undefined' && $s.openModal) {
            var wrapperClass = 'custom-bundle-builder-modal scheme';
            if (schemeClass) {
              wrapperClass += ' ' + schemeClass;
            }
            var modalOptions = infoType ? { cssClass: ['bundle-info', 'bundle-info-' + infoType] } : undefined;
            $s.openModal('<div class="' + wrapperClass + '">' + html + '</div>', 'bundle-info', modalOptions);
          }
        });
      });
    }

    getSelectedColorsCount() {
      return this.state.selectedColors.filter(Boolean).length;
    }

    isColorsSelectionComplete() {
      return this.getSelectedColorsCount() >= this.slotsCount;
    }

    getModalColorsTitle() {
      if (this.isColorsSelectionComplete()) {
        return this.getPickedModalLabel();
      }
      var remaining = this.slotsCount - this.getSelectedColorsCount();
      return this.formatPickerLabel(remaining > 0 ? remaining : this.slotsCount);
    }

    applyModalCompleteState(modalRoot) {
      if (!modalRoot) return;
      var isComplete = this.isColorsSelectionComplete();
      var titleEl = modalRoot.querySelector('.bundle-colors-modal-title');
      var addBtn = modalRoot.querySelector('[data-bundle-add-color]');

      modalRoot.classList.toggle('bundle-colors-modal--complete', isComplete);

      if (titleEl) {
        titleEl.textContent = this.getModalColorsTitle();
      }
      if (addBtn) {
        addBtn.textContent = this.getModalAddButtonLabel(isComplete);
      }
      if (isComplete) {
        modalRoot.querySelectorAll('.bundle-colors-modal-item').forEach(function(el) {
          el.classList.remove('is-selected');
        });
      }
    }

    getLastSelectedColor() {
      for (var i = this.state.selectedColors.length - 1; i >= 0; i--) {
        if (this.state.selectedColors[i]) return this.state.selectedColors[i];
      }
      return null;
    }

    resolveConfigColorForSelection(selection, colorsList) {
      if (!selection || !colorsList || !colorsList.length) return null;
      var configIndex = selection.configIndex;
      if (configIndex !== undefined && configIndex !== null && configIndex !== '' && !isNaN(configIndex)) {
        var idx = parseInt(configIndex, 10);
        if (idx >= 0 && colorsList[idx]) return colorsList[idx];
      }
      var productId = selection.productId != null ? String(selection.productId) : '';
      var handle = selection.handle ? String(selection.handle) : '';
      for (var j = 0; j < colorsList.length; j++) {
        var c = colorsList[j];
        if (!c) continue;
        if (productId && String(c.product_id || c.productId || '') === productId) return c;
        if (handle && c.handle === handle) return c;
      }
      return null;
    }

    buildGallerySlidesHtml(images) {
      var slidesHtml = '';
      var list = (Array.isArray(images) ? images : []).filter(function(u) { return !!u; });
      var seen = {};
      list = list.filter(function(u) {
        if (seen[u]) return false;
        seen[u] = true;
        return true;
      });
      if (list.length) {
        list.forEach(function(imgUrl) {
          slidesHtml +=
            '<div class="bundle-colors-modal-slide keen-slider-slide">' +
              '<div class="bundle-colors-modal-main-image" style="background-image:url(' + imgUrl + ')"></div>' +
            '</div>';
        });
      }
      if (!slidesHtml) {
        slidesHtml =
          '<div class="bundle-colors-modal-slide keen-slider-slide">' +
            '<div class="bundle-colors-modal-main-image bundle-colors-modal-main-image--empty"></div>' +
          '</div>';
      }
      return slidesHtml;
    }

    syncModalGalleryFromColor(color, gallerySliders, opts) {
      if (!color || !gallerySliders || !gallerySliders.length) return;
      opts = opts || {};
      var self = this;
      var configHasImages = !!(color.images && Array.isArray(color.images) && color.images.length);
      var images = configHasImages ? color.images.slice() : [];
      images = images.filter(function(u) { return !!u; });
      if (!images.length && color.image) images = [color.image];

      function setGalleryHidden(hidden) {
        gallerySliders.forEach(function(gs) {
          var wrap = gs.wrapper && gs.wrapper.closest('.bundle-colors-modal-gallery-wrap');
          if (wrap) wrap.classList.toggle('is-gallery-hidden', !!hidden);
        });
      }

      var rebuildGallery = function(imgs) {
        var slidesHtml = self.buildGallerySlidesHtml(imgs);
        gallerySliders.forEach(function(gs) {
          if (!gs || !gs.wrapper) return;
          gs.wrapper.innerHTML = slidesHtml;
          if (gs.instance && typeof gs.instance.refresh === 'function') {
            gs.instance.refresh();
            if (typeof gs.instance.moveToIdx === 'function') gs.instance.moveToIdx(0);
          }
        });
      };

      setGalleryHidden(true);
      rebuildGallery(images);

      if (!configHasImages && color.handle) {
        var handle = String(color.handle).trim();
        if (!handle) {
          setGalleryHidden(false);
          return;
        }
        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(prod) {
            if (typeof opts.isStale === 'function' && opts.isStale()) return;
            if (!prod || !prod.images) {
              setGalleryHidden(false);
              return;
            }

            var imagesData = prod.images || [];
            var imagesArr = [];
            if (Array.isArray(imagesData)) imagesArr = imagesData;
            else if (imagesData && typeof imagesData === 'object') imagesArr = [imagesData];

            var fetched = imagesArr
              .map(function(im) {
                if (!im) return '';
                if (typeof im === 'string') return im;
                return im.src || im.url || (im.image && im.image.src) || '';
              })
              .filter(function(u) { return !!u; });

            if (!fetched.length && prod.featured_image && (prod.featured_image.src || prod.featured_image.url)) {
              fetched = [prod.featured_image.src || prod.featured_image.url];
            }
            rebuildGallery(fetched);
            setGalleryHidden(false);
          })
          .catch(function() {
            setGalleryHidden(false);
          });
        return;
      }

      setGalleryHidden(false);
    }

    addColor(colorData) {
      for (var i = 0; i < this.state.selectedColors.length; i++) {
        if (!this.state.selectedColors[i]) {
          this.state.selectedColors[i] = colorData;
          break;
        }
      }
      this.render();
    }

    removeColorAt(index) {
      if (index < 0 || index >= this.slotsCount) return;
      this.state.selectedColors[index] = null;
      this.render();
    }

    buildColorsModalHtml() {
      var shapeKey = this.state.selectedSizeShapeKey;

      var popupItemTitle = (this.config && this.config.popup_item_title) || '';
      var popupItemDescription = (this.config && this.config.popup_item_description) || '';

      var colorsAll = this.getColorsForShapeKey(shapeKey);
      var colors = (Array.isArray(colorsAll) ? colorsAll : []).filter(function(c) {
        return !!c && c.available !== false;
      });
      this._colorsForModal = colors;

      var initialColor = colors.length ? colors[0] : null;
      if (this.isColorsSelectionComplete()) {
        var lastSelected = this.getLastSelectedColor();
        if (lastSelected) {
          var resolvedInitial = this.resolveConfigColorForSelection(lastSelected, colors);
          initialColor = resolvedInitial || {
            title: lastSelected.title || '',
            handle: lastSelected.handle || '',
            image: lastSelected.image || '',
            images: lastSelected.image ? [lastSelected.image] : [],
            popup_title: '',
            popup_description: ''
          };
        }
      }
      var initialTitle = initialColor && initialColor.title ? initialColor.title : '';
      var initialPopupTitle = initialColor && initialColor.popup_title ? initialColor.popup_title : '';
      var initialPopupDescription = initialColor && initialColor.popup_description ? initialColor.popup_description : '';

      var slotsHtml = '';
      for (var i = 0; i < this.state.selectedColors.length; i++) {
        var c = this.state.selectedColors[i];
        var label = c ? '' : (i + 1).toString();
        var filledClass = c ? ' is-filled' : '';
        var hasColorClass = c ? ' has-color' : '';
        var thumbStyle = c && c.image ? ' style="background-image:url(' + c.image + ')"' : '';
        var thumbClass = 'bundle-pick-colors-slot-thumb' + (c ? ' is-filled' : '');
        var closeSvg = '<svg aria-hidden="true" viewBox="0.06055 0.06055 8 8" fill="none"><path d="M1.06055 7.06055L7.06055 1.06055M1.06055 1.06055L7.06055 7.06055" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>';
        slotsHtml +=
          '<div class="bundle-colors-modal-slot bundle-pick-colors-slot' + filledClass + hasColorClass + '" data-bundle-modal-slot="' + i + '">' +
            '<div class="bundle-colors-modal-slot-inner">' +
              '<div class="' + thumbClass + '"' + thumbStyle + '></div>' +
              '<span class="bundle-pick-colors-slot-label">' + label + '</span>' +
            '</div>' +
            '<button type="button" class="bundle-colors-modal-slot-remove no-highlight-hover" data-bundle-remove-modal-slot="' + i + '" aria-label="' + (this.dataset.modalRemoveSlotLabel || 'Remove selection') + '">' + closeSvg + '</button>' +
          '</div>';
      }

      var gridHtml = '';
      var firstAvailableIndex = -1;
      colors.forEach(function(color, index) {
        var available = color.available !== false;
        if (firstAvailableIndex < 0 && available) firstAvailableIndex = index;
        var title = color.title || '';
        var image = color.image || '';
        var badges = color.badges || [];
        if (!available) badges = ['Out of stock'];
        var badgesHtml = '';
        var primaryBadgeLabel = '';
        var primaryBadgeScheme = '';
        if (badges && badges.length) {
          badges.forEach(function(b) {
            var label = String(b);
            var lower = label.toLowerCase();
            var schemeClass =
              lower === 'new'
                ? 'scheme color-scheme-2'
                : lower === 'best seller'
                  ? 'scheme color-scheme-4'
                  : lower === 'out of stock'
                    ? 'scheme color-scheme-out-of-stock'
                    : 'scheme color-scheme-4';
            if (!primaryBadgeLabel && (lower === 'new' || lower === 'best seller')) {
              primaryBadgeLabel = label;
              primaryBadgeScheme = schemeClass;
            }
            badgesHtml += '<span class="bundle-colors-modal-badge ' + schemeClass + '">' + label + '</span>';
          });
        }
        var selectedClass = (index === firstAvailableIndex && firstAvailableIndex >= 0) ? ' is-selected' : '';
        var variantId = color.variant_id || '';
        var disabledClass = !available ? ' is-disabled is-out-of-stock' : '';
        var btnHtml =
          '<button type="button" class="bundle-colors-modal-item' + selectedClass + disabledClass + '" ' +
            'data-bundle-color-id="' + String(color.product_id || '') + '" ' +
            (variantId ? 'data-bundle-color-variant-id="' + String(variantId) + '" ' : '') +
            'data-bundle-color-available="' + (available ? 'true' : 'false') + '" ' +
            'data-bundle-color-title="' + String(title).replace(/"/g, '&quot;') + '" ' +
            'data-bundle-color-index="' + index + '" ' +
            (color.handle ? 'data-bundle-color-handle="' + String(color.handle).replace(/"/g, '&quot;') + '" ' : '') +
            (image ? 'data-bundle-color-image="' + String(image).replace(/"/g, '&quot;') + '" ' : '') +
            (color.popup_title ? 'data-bundle-color-popup-title="' + String(color.popup_title).replace(/"/g, '&quot;') + '" ' : '') +
            (color.popup_description ? 'data-bundle-color-popup-description="' + String(color.popup_description).replace(/"/g, '&quot;') + '" ' : '') +
            (primaryBadgeLabel ? 'data-bundle-color-badge-label="' + String(primaryBadgeLabel).replace(/"/g, '&quot;') + '" data-bundle-color-badge-scheme="' + primaryBadgeScheme + '" ' : '') +
            (!available ? 'disabled ' : '') +
          '>' +
            '<div class="bundle-colors-modal-item-thumb-wrap">' +
              '<div class="bundle-colors-modal-item-thumb">' +
                '<div class="bundle-colors-modal-item-thumb-img"' +
                  (image ? ' style="background-image:url(' + image + ')"' : '') +
                '></div>' +
              '</div>' +
              (badgesHtml ? '<div class="bundle-colors-modal-item-badges">' + badgesHtml + '</div>' : '') +
            '</div>' +
            '<div class="bundle-colors-modal-item-meta">' +
              '<span class="bundle-colors-modal-item-title">' + title.split('(')[0].trim() + '</span>' +
            '</div>' +
          '</button>';
        gridHtml += '<div class="grid-item thumb-item one-quarter">' + btnHtml + '</div>';
      });

      // Left gallery starts with the initially selected color (and later we rebuild on click).
      var slidesHtml = '';
      var initialImages =
        (initialColor && initialColor.images && initialColor.images.length ? initialColor.images : []) ||
        [];
      // Sometimes Shopify products can contain empty image URLs in the serialized data.
      // Filter them out so we can reliably fall back to the main thumb image.
      initialImages = (Array.isArray(initialImages) ? initialImages : []).filter(function(u) { return !!u; });
      if (!initialImages.length && initialColor && initialColor.image) {
        initialImages = [initialColor.image];
      }

      if (initialImages && initialImages.length) {
        initialImages.forEach(function(img) {
          slidesHtml +=
            '<div class="bundle-colors-modal-slide keen-slider-slide">' +
              (img
                ? '<div class="bundle-colors-modal-main-image" style="background-image:url(' + img + ')"></div>'
                : '<div class="bundle-colors-modal-main-image bundle-colors-modal-main-image--empty"></div>') +
            '</div>';
        });
      }
      if (!slidesHtml) {
        slidesHtml =
          '<div class="bundle-colors-modal-slide keen-slider-slide">' +
            '<div class="bundle-colors-modal-main-image bundle-colors-modal-main-image--empty"></div>' +
          '</div>';
      }

      var arrowPrevSvg = '<svg aria-hidden="true" role="presentation" class="icon icon-chevron-left" viewBox="0 0 32 32"><path class="stroke" d="M22,27,10,16,22,5"/></svg>';
      var arrowNextSvg = '<svg aria-hidden="true" role="presentation" class="icon icon-chevron-right" viewBox="0 0 32 32"><path class="stroke" d="M10,5,22,16,10,27"/></svg>';

      var galleryInnerHtml =
          '<div class="keen-arrows sides inside bundle-colors-modal-arrows medium-down--hide">' +
            '<button type="button" class="keen-arrow prev frame circle" aria-label="Previous">' + arrowPrevSvg + '</button>' +
            '<button type="button" class="keen-arrow next frame circle" aria-label="Next">' + arrowNextSvg + '</button>' +
          '</div>' +
          '<div class="bundle-colors-modal-slider keen-slider">' +
            slidesHtml +
          '</div>';

      // Desktop: gallery in left column
      var leftHtml =
        '<div class="bundle-colors-modal-left bundle-colors-modal-gallery-wrap large-up--block medium-down--hide">' +
          galleryInnerHtml +
        '</div>';

      var isComplete = this.isColorsSelectionComplete();
      var modalTitle = this.getModalColorsTitle();
      var addBtnLabel = this.getModalAddButtonLabel(isComplete);
      var modalCompleteClass = isComplete ? ' bundle-colors-modal--complete' : '';
      var rightHtml =
        '<div class="bundle-colors-modal-right">' +
          '<div class="bundle-colors-modal-header">' +
            '<div class="bundle-colors-modal-title">' + modalTitle + '</div>' +
            '<div class="bundle-colors-modal-slots flex justify-content-start align-items-center">' + slotsHtml + '</div>' +
          '</div>' +
          '<div class="bundle-colors-modal-gallery-mobile bundle-colors-modal-gallery-wrap large-up--hide">' +
            galleryInnerHtml +
          '</div>' +
          '<div class="bundle-colors-modal-grid-wrapper"><div class="bundle-colors-modal-grid grid">' + gridHtml + '</div></div>' +
          '<div class="bundle-colors-modal-footer">' +
            '<button type="button" class="bundle-colors-modal-accordion flex direction-column justify-content-center align-items-start" data-bundle-color-accordion aria-expanded="false">' +
              '<span class="bundle-colors-modal-accordion-badge" data-bundle-color-accordion-badge></span>' +
              '<span class="bundle-colors-modal-accordion-head">' +
                '<span class="bundle-colors-modal-accordion-heading flex justify-content-start align-items-center">' +
                  '<span class="bundle-colors-modal-accordion-title">' +
                    (initialPopupTitle && String(initialPopupTitle).trim().length > 0 ? ((initialTitle || this.getModalSelectedItemFallback()) + ': ') : (initialTitle || this.getModalSelectedItemFallback())) +
                  '</span>' +
                  '<span class="bundle-colors-modal-accordion-subtitle">' + (initialPopupTitle || '') + '</span>' +
                '</span>' +
                '<span class="bundle-colors-modal-accordion-chevron" aria-hidden="true" ' + (!initialPopupDescription ? 'style="display:none;"' : '') + '>' +
                  '<svg class="icon icon-chevron-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg>' +
                '</span>' +
              '</span>' +
            '</button>' +
            '<div class="bundle-colors-modal-accordion-panel" style="display:none;" hidden>' +
              '<div class="bundle-colors-modal-accordion-content">' +
                '<p class="bundle-colors-modal-accordion-text flex justify-content-start align-items-center">' + (initialPopupDescription || '') + '</p>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="btn v2 bundle-colors-modal-add-color" data-bundle-add-color>' + addBtnLabel + '</button>' +
          '</div>' +
        '</div>';

      var html =
        '<div class="custom-bundle-builder-modal scheme color-scheme-cf3c2ccb-27a2-43da-bbba-810b3c148406">' +
          '<div class="bundle-colors-modal' + modalCompleteClass + '">' +
            '<div class="bundle-colors-modal-body">' +
              leftHtml +
              rightHtml +
            '</div>' +
          '</div>' +
        '</div>';

      return html;
    }

    syncBundleColorsModalMetaHeights(modalRoot) {
      if (!modalRoot) return;
      var grid = modalRoot.querySelector('.bundle-colors-modal-grid');
      if (!grid) return;

      var thumbItems = Array.from(grid.querySelectorAll('.thumb-item'));
      var metas = thumbItems.map(function(item) {
        return item.querySelector('.bundle-colors-modal-item-meta');
      }).filter(Boolean);

      metas.forEach(function(meta) {
        meta.style.minHeight = '';
      });

      if (window.getComputedStyle(grid).flexWrap === 'nowrap') return;

      var rows = [];
      thumbItems.forEach(function(item, index) {
        var meta = metas[index];
        if (!meta) return;
        var top = item.offsetTop;
        var row = rows.find(function(r) { return Math.abs(r.top - top) <= 2; });
        if (!row) {
          row = { top: top, metas: [] };
          rows.push(row);
        }
        row.metas.push(meta);
      });

      rows.forEach(function(row) {
        if (row.metas.length < 2) return;
        var maxHeight = 0;
        row.metas.forEach(function(meta) {
          maxHeight = Math.max(maxHeight, meta.getBoundingClientRect().height);
        });
        if (maxHeight <= 0) return;
        row.metas.forEach(function(meta) {
          meta.style.minHeight = maxHeight + 'px';
        });
      });
    }

    scheduleBundleColorsModalMetaSync(modalRoot) {
      var self = this;
      requestAnimationFrame(function() {
        self.syncBundleColorsModalMetaHeights(modalRoot);
      });
    }

    openColorsModal() {
      if (typeof $s === 'undefined' || !$s.openModal) {
        console.warn('Bundle modal not available');
        return;
      }
      var html = this.buildColorsModalHtml();
      $s.openModal(html, 'bundle-pick-colors');

      var modalRoot = document.querySelector('.bundle-colors-modal');
      if (modalRoot) {
        this.bindColorsModalEvents(modalRoot);
        this.scheduleBundleColorsModalMetaSync(modalRoot);
      }
    }

    syncLineItemProperties() {
      if (!this.form) return;

      if (this.inputTopCoat && this.state.selectedTopCoat) {
        this.inputTopCoat.value = this.state.selectedTopCoat.title;
      }
      if (this.inputAccessory && this.state.selectedAccessory) {
        this.inputAccessory.value = this.state.selectedAccessory.title;
      }

      var colors = this.state.selectedColors;
      if (this.inputColor1) this.inputColor1.value = colors[0] ? this.formatColorTitleForCart(colors[0]) : '';
      if (this.inputColor2) this.inputColor2.value = colors[1] ? this.formatColorTitleForCart(colors[1]) : '';
      if (this.inputColor3) this.inputColor3.value = colors[2] ? this.formatColorTitleForCart(colors[2]) : '';
      if (this.inputColor4) this.inputColor4.value = colors[3] ? this.formatColorTitleForCart(colors[3]) : '';
      if (this.inputColor5) this.inputColor5.value = colors[4] ? this.formatColorTitleForCart(colors[4]) : '';
    }

    updatePickButtonLabel() {
      var remaining = this.slotsCount - this.getSelectedColorsCount();
      var label = remaining > 0 ? this.formatPickerLabel(remaining) : (this.isProductAvailable() ? 'Add to Cart' : this.formatPickerLabel(this.slotsCount));

      if (this.pickButton) {
        this.pickButton.textContent = label;
      }
      if (this.pickColorsSmallLabel) {
        if (remaining > 0) {
          this.pickColorsSmallLabel.textContent = this.formatPickerLabel(remaining);
        } else if (this.getSelectedColorsCount() >= this.slotsCount) {
          this.pickColorsSmallLabel.textContent = this.getPickedModalLabel();
        }
      }
    }

    bindColorsModalEvents(modalRoot) {
      var self = this;
      var items = modalRoot.querySelectorAll('.bundle-colors-modal-item');
      if (!items.length) return;

      if (!modalRoot.dataset.bundleColorsMetaResizeBound) {
        modalRoot.dataset.bundleColorsMetaResizeBound = 'true';
        var resizeTimer;
        window.addEventListener('resize', function onBundleColorsMetaResize() {
          if (!document.body.contains(modalRoot)) {
            window.removeEventListener('resize', onBundleColorsMetaResize);
            return;
          }
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            self.syncBundleColorsModalMetaHeights(modalRoot);
          }, 150);
        });
      }

      var accordionTitleEl = modalRoot.querySelector('.bundle-colors-modal-accordion-title');
      var accordionSubtitleEl = modalRoot.querySelector('.bundle-colors-modal-accordion-subtitle');
      var accordionTextEl = modalRoot.querySelector('.bundle-colors-modal-accordion-text');
      var accordionBadgeEl = modalRoot.querySelector('[data-bundle-color-accordion-badge]');
      var accordionPanelEl = modalRoot.querySelector('.bundle-colors-modal-accordion-panel');
      var accordionChevronEl = modalRoot.querySelector('.bundle-colors-modal-accordion-chevron');
      var addBtn = modalRoot.querySelector('[data-bundle-add-color]');
      var accordionToggle = modalRoot.querySelector('[data-bundle-color-accordion]');

      var gallerySliders = [];
      if (typeof KeenSlider !== 'undefined') {
        modalRoot.querySelectorAll('.bundle-colors-modal-gallery-wrap').forEach(function(galleryWrap) {
          var sliderWrapper = galleryWrap.querySelector('.bundle-colors-modal-slider');
          if (!sliderWrapper) return;
          var prevBtn = galleryWrap.querySelector('.keen-arrow.prev');
          var nextBtn = galleryWrap.querySelector('.keen-arrow.next');
          var sliderInstance = new KeenSlider(sliderWrapper, {
            slidesPerView: 1.1,
            loop: true,
            drag: true,
            spacing: 8,
            prevButton: prevBtn || undefined,
            nextButton: nextBtn || undefined,
            breakpoints: {
              '(max-width: 640px)': {
                slidesPerView: 1.3
              }
            }
          });
          gallerySliders.push({ wrapper: sliderWrapper, instance: sliderInstance });
        });
      } else {
        // If KeenSlider isn't available, we still keep a list of wrappers
        // so we can rebuild the slides on click.
        modalRoot.querySelectorAll('.bundle-colors-modal-gallery-wrap').forEach(function(galleryWrap) {
          var sliderWrapper = galleryWrap.querySelector('.bundle-colors-modal-slider');
          if (!sliderWrapper) return;
          gallerySliders.push({ wrapper: sliderWrapper, instance: null });
        });
      }

      function updateAccordionVisibility() {
        if (!accordionToggle) return;
        var count = self.getSelectedColorsCount();
        var isFull = count >= self.slotsCount;
        accordionToggle.style.display = isFull ? 'none' : '';
        if (accordionPanelEl && isFull) {
          accordionPanelEl.style.display = 'none';
          accordionPanelEl.hidden = true;
          accordionToggle.classList.remove('is-open');
          accordionToggle.setAttribute('aria-expanded', 'false');
        }
      }

      function selectItem(btn) {
        if (!btn || btn.dataset.bundleColorAvailable === 'false') return;
        items.forEach(function(i) { i.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var title = btn.dataset.bundleColorTitle || '';
        var popupTitle = btn.dataset.bundleColorPopupTitle || '';
        var popupDescription = btn.dataset.bundleColorPopupDescription || '';
        var badgeLabel = btn.dataset.bundleColorBadgeLabel || '';
        var badgeScheme = btn.dataset.bundleColorBadgeScheme || '';
        var canExpand = popupDescription && String(popupDescription).trim().length > 0;
        var hasAccordionTitle = popupTitle && String(popupTitle).trim().length > 0;
        if (accordionTitleEl) {
          var baseTitle = (title && title.split('(')[0].trim()) || self.getModalSelectedItemFallback();
          accordionTitleEl.textContent = baseTitle + (hasAccordionTitle ? ': ' : '');
        }
        if (accordionSubtitleEl) {
          accordionSubtitleEl.textContent = popupTitle || '';
        }
        if (accordionTextEl) {
          accordionTextEl.textContent = popupDescription || '';
        }
        if (accordionBadgeEl) {
          if (badgeLabel) {
            accordionBadgeEl.innerHTML = '<span class="bundle-colors-modal-badge ' + badgeScheme + '">' + badgeLabel + '</span>';
          } else {
            accordionBadgeEl.innerHTML = '';
          }
        }

        // Disable accordion when there is no subtitle/value
        if (accordionToggle) {
          accordionToggle.classList.toggle('is-disabled', !canExpand);
          accordionToggle.setAttribute('aria-disabled', canExpand ? 'false' : 'true');
          if (accordionChevronEl) accordionChevronEl.style.display = canExpand ? '' : 'none';
          if (!canExpand) {
            accordionToggle.classList.remove('is-open');
            accordionToggle.setAttribute('aria-expanded', 'false');
            if (accordionPanelEl) {
              accordionPanelEl.classList.remove('is-open');
              accordionPanelEl.style.display = 'none';
              accordionPanelEl.hidden = true;
            }
          }
        }

        // Rebuild left carousel with *all images* of the selected color product.
        var idx = parseInt(btn.dataset.bundleColorIndex || '0', 10);
        var selectedColor = (self._colorsForModal && !isNaN(idx) && self._colorsForModal[idx]) ? self._colorsForModal[idx] : null;

        if (selectedColor) {
          self.syncModalGalleryFromColor(selectedColor, gallerySliders, {
            isStale: function() { return !btn.classList.contains('is-selected'); }
          });
        }
      }

      updateAccordionVisibility();
      if (self.isColorsSelectionComplete()) {
        var lastSelected = self.getLastSelectedColor();
        if (lastSelected) {
          var colorsList = self._colorsForModal || [];
          var resolvedColor = self.resolveConfigColorForSelection(lastSelected, colorsList);
          var colorForGallery = resolvedColor || {
            title: lastSelected.title,
            handle: lastSelected.handle,
            image: lastSelected.image,
            images: lastSelected.image ? [lastSelected.image] : []
          };
          self.syncModalGalleryFromColor(colorForGallery, gallerySliders, {
            isStale: function() {
              return !self.isColorsSelectionComplete() || !modalRoot.isConnected;
            }
          });
        }
      } else {
        var firstAvailable = Array.from(items).find(function(i) { return i.dataset.bundleColorAvailable !== 'false'; });
        if (firstAvailable) selectItem(firstAvailable);
      }
      self.applyModalCompleteState(modalRoot);

      items.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (modalRoot.classList.contains('bundle-colors-modal--complete')) return;
          if (this.dataset.bundleColorAvailable === 'false') return;
          selectItem(btn);
        });
      });

      function updateModalSlots(root, selectedColors) {
        var modalSlots = root.querySelectorAll('.bundle-colors-modal-slot');
        (selectedColors || []).forEach(function(data, index) {
          var slotEl = modalSlots[index];
          if (!slotEl) return;
          var labelEl = slotEl.querySelector('.bundle-pick-colors-slot-label');
          var thumbEl = slotEl.querySelector('.bundle-pick-colors-slot-thumb');
          if (labelEl) labelEl.textContent = data ? '' : (index + 1).toString();
          if (thumbEl) {
            if (data) {
              thumbEl.classList.add('is-filled');
              thumbEl.style.backgroundImage = data.image ? ('url(' + data.image + ')') : '';
            } else {
              thumbEl.classList.remove('is-filled');
              thumbEl.style.backgroundImage = '';
            }
          }
          if (data) slotEl.classList.add('has-color'); else slotEl.classList.remove('has-color');
        });
      }

      modalRoot.querySelectorAll('[data-bundle-remove-modal-slot]').forEach(function(removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var index = parseInt(this.getAttribute('data-bundle-remove-modal-slot'), 10);
          if (isNaN(index) || index < 0 || index >= self.slotsCount) return;
          self.removeColorAt(index);
          updateModalSlots(modalRoot, self.state.selectedColors);
          self.render();
          updateAccordionVisibility();
          self.applyModalCompleteState(modalRoot);
          if (!self.isColorsSelectionComplete()) {
            var nextAvail = Array.from(items).find(function(i) { return i.dataset.bundleColorAvailable !== 'false'; });
            if (nextAvail) selectItem(nextAvail);
          }
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function() {
          var count = self.getSelectedColorsCount();
          if (count === self.slotsCount) {
            if (typeof $s !== 'undefined' && $s.closeModal) {
              $s.closeModal();
            }
            return;
          }
          var selected = modalRoot.querySelector('.bundle-colors-modal-item.is-selected');
          if (!selected || selected.dataset.bundleColorAvailable === 'false') return;
          var vid = selected.dataset.bundleColorVariantId;
          var idx = selected.dataset.bundleColorIndex;
          var configIndex = idx !== undefined && idx !== '' ? parseInt(idx, 10) : -1;
          var shapeKey = self.state.selectedSizeShapeKey;
          var configList = self.getColorsForShapeKey(shapeKey);
          var cfg = configIndex >= 0 && configList[configIndex] ? configList[configIndex] : null;
          var variantFromConfig = cfg && (cfg.variant_id || cfg.variantId) ? parseInt(cfg.variant_id || cfg.variantId, 10) : null;
          var colorData = {
            productId: selected.dataset.bundleColorId ? parseInt(selected.dataset.bundleColorId, 10) : null,
            variantId: vid ? parseInt(vid, 10) : variantFromConfig,
            variant_id: vid ? parseInt(vid, 10) : variantFromConfig,
            title: selected.dataset.bundleColorTitle || '',
            handle: selected.dataset.bundleColorHandle || '',
            image: selected.dataset.bundleColorImage || '',
            configIndex: configIndex
          };
          if (self.isPickerMode && !self.shouldResetOnOptionChange()) {
            colorData.optionKey = shapeKey;
            colorData.optionLabel = self.getPickerOptionLabel(shapeKey);
          }
          self.addColor(colorData);
          updateModalSlots(modalRoot, self.state.selectedColors);
          self.render();
          updateAccordionVisibility();
          self.applyModalCompleteState(modalRoot);
        });
      }

      if (accordionToggle && accordionPanelEl) {
        accordionToggle.addEventListener('click', function() {
          if (accordionToggle.classList.contains('is-disabled')) return;
          var isOpen = accordionPanelEl.classList.toggle('is-open');
          accordionPanelEl.style.display = isOpen ? '' : 'none';
          accordionPanelEl.hidden = !isOpen;
          accordionToggle.classList.toggle('is-open', isOpen);
          accordionToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }
    }

    renderSlots() {
      if (!this.slotButtons) return;
      var self = this;
      this.slotButtons.forEach(function(slotEl) {
        var index = parseInt(slotEl.dataset.bundleColorSlot, 10);
        var data = self.state.selectedColors[index];
        var labelEl = slotEl.querySelector('[data-bundle-slot-label]');
        var thumbEl = slotEl.querySelector('[data-bundle-slot-thumb]');
        var slotWrapper = slotEl.closest('.bundle-pick-colors-slot');

        if (!labelEl || !thumbEl) return;

        if (data) {
          labelEl.textContent = self.formatColorTitleForCart(data);
          slotEl.classList.add('is-filled');
          thumbEl.style.backgroundImage = data.image ? ('url(' + data.image + ')') : '';
          if (slotWrapper) slotWrapper.classList.add('has-color');
        } else {
          labelEl.textContent = (index + 1).toString();
          slotEl.classList.remove('is-filled');
          thumbEl.style.backgroundImage = '';
          if (slotWrapper) slotWrapper.classList.remove('has-color');
        }
      });
    }

    updatePickColorsAvailability() {
      var canPurchase = this.isProductAvailable();
      if (this.pickColorsRoot) {
        this.pickColorsRoot.classList.toggle('bundle-pick-colors--unavailable', !canPurchase);
      }
      if (this.slotButtons && this.slotButtons.length) {
        this.slotButtons.forEach(function(slotBtn) {
          slotBtn.disabled = !canPurchase;
          slotBtn.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
        });
      }
      if (this.pickColorsRoot) {
        this.pickColorsRoot.querySelectorAll('[data-bundle-remove-slot]').forEach(function(removeBtn) {
          removeBtn.disabled = !canPurchase;
          removeBtn.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
        });
      }
    }

    updateButtonsVisibility() {
      var count = this.getSelectedColorsCount();
      var complete = count >= this.slotsCount;
      var canPurchase = this.isProductAvailable();

      if (this.pickButton) {
        if (!canPurchase) {
          this.pickButton.style.display = 'none';
        } else {
          this.pickButton.style.display = count < this.slotsCount ? '' : 'none';
        }
      }
      if (this.addButton) {
        this.addButton.style.display = complete && canPurchase ? '' : 'none';
      }

      var productButtons = this.form ? this.form.querySelector('product-buttons') : null;
      if (productButtons && !canPurchase) {
        var soldOutEl = productButtons.querySelector('.sold-out-message');
        if (soldOutEl) soldOutEl.style.display = 'none';
      }

      this.updatePickColorsAvailability();
    }

    updateSizeShapeWarning() {
      if (!this.sizeShapeWarning) return;
      var hasColors = this.getSelectedColorsCount() > 0;
      this.sizeShapeWarning.classList.toggle('is-visible', hasColors);
      if (hasColors) {
        this.sizeShapeWarning.textContent = this.shouldResetOnOptionChange()
          ? this.getOptionChangeWarningMessage()
          : this.getOptionChangeKeepMessage();
      }
    }

    render() {
      this.renderSlots();
      this.updatePickButtonLabel();
      this.syncLineItemProperties();
      this.updateButtonsVisibility();
      this.updateSizeShapeWarning();
    }
  }

  customElements.define('custom-bundle-builder', CustomBundleBuilder);
}

